import { StudentAssessmentType } from "../../../types/Assessment";
import { post } from "../../../utils/axios-config";
import { STUDENT_ASSESSMENTS } from "../../../utils/constants";

export const createStudentAssessment = async (data: StudentAssessmentType) => await post<StudentAssessmentType, string>(STUDENT_ASSESSMENTS, data);
